import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Repeater } from "./_shared";

export default function AssetsTab({ client, onSave, canEdit }) {
  const [houses, setHouses] = useState(client.house_owned || []);
  const [cars, setCars] = useState(client.cars_owned || []);
  const [other, setOther] = useState(client.other_assets || []);
  const [loans, setLoans] = useState(client.loans || []);
  const [debts, setDebts] = useState(client.other_debts || []);

  const save = () =>
    onSave({ house_owned: houses, cars_owned: cars, other_assets: other, loans, other_debts: debts });

  return (
    <div className="space-y-8">
      <Repeater
        title="Homes owned"
        items={houses} setItems={setHouses}
        template={() => ({ id: crypto.randomUUID(), address: "", value: 0, loan_outstanding: 0, loan_end_date: "", is_primary: false })}
        columns={[
          ["address", "Address", "text"],
          ["value", "Value (₹)", "number"],
          ["loan_outstanding", "Loan o/s (₹)", "number"],
          ["loan_end_date", "Loan ends", "date"],
        ]}
        canEdit={canEdit}
        keyName="house"
      />
      <Repeater
        title="Cars"
        items={cars} setItems={setCars}
        template={() => ({ id: crypto.randomUUID(), model: "", purchase_date: "", expected_replacement_age: 0 })}
        columns={[
          ["model", "Model", "text"],
          ["purchase_date", "Purchased", "date"],
          ["expected_replacement_age", "Replace at (yrs)", "number"],
        ]}
        canEdit={canEdit}
        keyName="car"
      />
      <Repeater
        title="Other assets"
        items={other} setItems={setOther}
        template={() => ({ id: crypto.randomUUID(), type: "", value: 0 })}
        columns={[["type", "Type", "text"], ["value", "Value (₹)", "number"]]}
        canEdit={canEdit}
        keyName="other-asset"
      />
      <Repeater
        title="Loans"
        items={loans} setItems={setLoans}
        template={() => ({ id: crypto.randomUUID(), type: "", principal: 0, emi: 0, start_date: "", end_date: "", lender: "" })}
        columns={[
          ["type", "Type", "text"],
          ["principal", "Principal (₹)", "number"],
          ["emi", "EMI (₹)", "number"],
          ["end_date", "Ends", "date"],
          ["lender", "Lender", "text"],
        ]}
        canEdit={canEdit}
        keyName="loan"
      />
      <Repeater
        title="Other debts"
        items={debts} setItems={setDebts}
        template={() => ({ id: crypto.randomUUID(), description: "", amount: 0, due_date: "" })}
        columns={[
          ["description", "Description", "text"],
          ["amount", "Amount (₹)", "number"],
          ["due_date", "Due", "date"],
        ]}
        canEdit={canEdit}
        keyName="debt"
      />

      {canEdit && <Button onClick={save} data-testid="save-assets-btn">Save assets & liabilities</Button>}
    </div>
  );
}
